import React from 'react';
import { INamedFilterBuilderInfoProps } from '../types';
import { useCurrentUrl } from '../../../utils/routing';
import { appRoutes } from '../../../path';
import * as BuilderInfoUI from '../BuilderInfoUI';
import {
  FilterInfo,
  GoToDictionaryAction,
  InfoPopupHeader,
  InfoPopupSchema,
  ShowInReport,
} from '../components';
import {
  getUrlForDataSharing,
  SearchParamsDataSharingEnum,
} from '../../../utils/searchParamsDataSharing';

export default ({ namedFilter, onExpand }: INamedFilterBuilderInfoProps) => {
  const {
    id,
    description,
    conditions,
    logicOps,
    name,
    comment,
    createdAt,
    creator,
    schema,
    type,
    editor,
    editedAt,
  } = namedFilter;

  const { isReportInUrl } = useCurrentUrl();

  const reportUrl = getUrlForDataSharing(appRoutes.report.query, {
    type: SearchParamsDataSharingEnum.NamedFilter,
    namedFilterId: id,
    schemaId: schema.id,
  });

  const dictionaryUrl = getUrlForDataSharing(appRoutes.dictionary.filter, {
    type: SearchParamsDataSharingEnum.Dictionary,
    schemaId: schema.id,
    term: name,
  });

  return (
    <>
      <InfoPopupHeader
        name={name}
        description={description}
        creator={creator}
        comment={comment}
        createdAt={createdAt}
        editor={editor}
        editedAt={editedAt}
        link={
          isReportInUrl && dictionaryUrl ? (
            <GoToDictionaryAction dictionaryUrl={dictionaryUrl} />
          ) : null
        }
      />
      <BuilderInfoUI.MainContent>
        <InfoPopupSchema name={schema.name} />
        <BuilderInfoUI.FooterRow>
          <FilterInfo filter={{ conditions, logicOps, type }} showExpanded />
        </BuilderInfoUI.FooterRow>
      </BuilderInfoUI.MainContent>
      {(onExpand || !isReportInUrl) && (
        <BuilderInfoUI.FooterContainer>
          {onExpand && (
            <BuilderInfoUI.PopupSecondaryButton
              type="button"
              onClick={onExpand}
              trackContext="filter"
              trackAction="expand"
              size="small"
            >
              Expand
            </BuilderInfoUI.PopupSecondaryButton>
          )}
          {!isReportInUrl && reportUrl && (
            <ShowInReport reportUrl={reportUrl} trackContext="named filter" />
          )}
        </BuilderInfoUI.FooterContainer>
      )}
    </>
  );
};
